// import { Link } from 'react-router-dom';

import { useEffect, useState } from 'react';

import RegularPage from '@/components/templates/RegularPageLayout';
import { useTypeSafeTranslation } from '@/i18n';

import axios from 'axios';
import '@/utils/apiUtil';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';

export default function Top() {
  const { t } = useTypeSafeTranslation();
  // 言語設定を取得する処理を入れておくことで、言語設定が変更されたときに再レンダリングされるようにしておく
  const language = useSelector<RootState>((state) => state.main.persistent.language);

  const [message, setMessage] = useState('');

  useEffect(() => {
    (async () => {
      const res = await axios.get('/api/hello');
      setMessage(res.data.message);
    })();
  });

  return (
    <RegularPage title={t('pages.top.title')}>
      <p>{message}</p>
      <p>{language}</p>
      <div style={{ height: '60vh' }}></div>
    </RegularPage>
  );
}
